<article id="inicio" class="loaded bare">
  <router-outlet></router-outlet>
</article>
